<nav id="nav" class="navbar navbar-expand-lg navbar-absolute fixed-top position-fixed navbar-transparent bg-dark">
  <div class="container-fluid position-relative" style="margin-left: 20px; margin-right: 20px">
    <div class="navbar-wrapper">
      <a class="navbar-brand" href="#"><img src="../../assets/pictures/header/logo.png" class="opacity-hover" alt=""></a>
    </div>
    <div class="navbar-wrapper">
      <a class="navbar-brand text-white" data-toggle="modal" data-target="#subscribe" href="#"><i class="material-icons">not_started</i> Get Started</a>
    </div>
    <button class="navbar-toggler" type="button" data-toggle="collapse" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
      <span class="sr-only">Toggle navigation</span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end">
      <ul class="navbar-nav">
        <span class="form-inline">
          <select class="form-search text-white rounded p-1" style="background-color: rgba(0, 0, 0, 0.6)" #selectedLang (change)="switchLang(selectedLang.value)">
            <option *ngFor="let language of translate.getLangs()" [value]="language"
                    [selected]="language === translate.currentLang">
              {{ language }}
            </option>
          </select>
        </span>
        <li class="nav-item">
          <a href="javascript:void(0)" class="nav-link" [routerLink]="['/annonces']">
            <i class="material-icons">dashboard</i>{{'browse' | translate}}
          </a>
        </li>
        <li class="nav-item">
          <a href="javascript:void(0)" class="nav-link" (click)="n_router.defaultRoute('map', true)">
            <i class="material-icons">room</i>MAP
          </a>
        </li>
        <li class="nav-item ">
          <a href="javascript:void(0)" class="nav-link" data-toggle="modal" data-target="#subscribe">
            <i class="material-icons">person_add</i> {{'register' | translate}}
          </a>
        </li>
        <li class="nav-item  active ">
          <a href="javascript:void(0)" class="nav-link" data-toggle="modal" data-target="#login">
            <i class="material-icons">fingerprint</i>   {{'login' | translate}}
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>

<!-------------------------------------------------LOGIN MODAL CONTENT ------------------------------------------------>
<!-- The Modal -->
<div class="modal fade" id="login" style="background-color: rgba(0, 0, 0, 0.6)">
  <div class="modal-dialog modal-lg">
    <div class="modal-content bg-transparent">
      <span class="alert alert-danger d-flex justify-content-center" *ngIf="error">{{error}}</span>
      <!--<span class="alert alert-danger d-flex justify-content-center" *ngIf="error">{{error}}</span>
      &lt;!&ndash; Modal Header &ndash;&gt;
      <div class="modal-header">
        <h5 class="modal-title">Connexion</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      &lt;!&ndash; Modal body &ndash;&gt;
      <div class="modal-body">
        <span class="text-danger" id="login-username-error"></span>
        <div class="form-group">
          <label for="name" class="connexion-labels">Email or username : </label>
          <input type="text" class="form-control input-group-sm" id="name" [(ngModel)]="username">
        </div>
        <span class="text-danger" id="login-password-error"></span>
        <div class="form-group">
          <label for="password" class="connexion-labels">Password :</label>
          <input type="password" class="form-control" id="password" [(ngModel)]="password">
        </div>
      </div>
      <div class="forgot-password d-flex justify-content-center">
        <a href=""> Mot de Passe Oublié ?</a>
      </div>
      &lt;!&ndash; Modal footer &ndash;&gt;
      <div class="modal-footer">
        <input type="submit" (click)="login()" class="btn btn-outline-primary" value="Connexion">
      </div>-->
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title text-white font-weight-bold">{{'citation' | translate}}</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="card card-login shadow-none">
        <div class="card-header card-header-rose text-center">
          <h4 class="card-title">{{'login' | translate}}</h4>
          <div class="social-line">
            <a href="#facebookLoginBlock" data-toggle="modal" class="btn btn-just-icon btn-link btn-white" onclick="FBlogin()">
              <i class="fa fa-facebook-square"></i>
            </a>
            <a href="javascript:void(0)" class="g-signin2 btn btn-just-icon btn-link btn-white" data-onsuccess="onSignIn">
              <i class="fa fa-google-plus"></i>
            </a>
          </div>
        </div>
        <div class="card-body ">
          <p class="card-description text-center">Join our services</p>
          <span class="bmd-form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="material-icons">email</i>
                  </span>
                </div>
                <input type="email" class="form-control" placeholder="Email Or Username..." required [(ngModel)]="username" name="username">
              </div>
              <span class="text-danger float-right" id="login-username-error"></span>
            </span>
          <span class="bmd-form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="material-icons">lock_outline</i>
                  </span>
                </div>
                <input type="password" class="form-control" placeholder="Password..." required [(ngModel)]="password" name="password">
              </div>
              <span class="text-danger float-right" id="login-password-error"></span>
            </span>
        </div>
        <div class="forgot-password d-flex justify-content-center">
          <a href="">{{'psw'|translate}} </a>
        </div>
        <div class="card-footer justify-content-center">
          <a href="javascript:void(0)" class="btn btn-rose btn-link btn-lg" (click)="login()">{{'login'|translate}}</a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-------------------------------------------------SUBSCRIBE MODAL CONTENT -------------------------------------------->
<!-- The Modal -->
<div class="modal fade" id="subscribe">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <span class="alert alert-danger d-flex justify-content-center" *ngIf="error">{{error}}</span>
      <!-- Modal Header
      <div class="modal-header" id="header-inscription">
        <h5 class="modal-title">Inscription</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-header d-none" id="header-confirmation">
        <h5 class="modal-title">Inscription: Confirmation d'email d'utilisateur <span *ngIf="username">{{username}}</span></h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      &lt;!&ndash; Modal body &ndash;&gt;
      <div class="modal-body" id="body-inscription">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6">
              <span class="text-danger" id="subscribe-username-error"></span>
              <div class="form-group">
                <label for="user-name" class="connexion-labels">Username : </label>
                <input type="text" class="form-control" id="user-name" [(ngModel)]="username">
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <span class="text-danger" id="subscribe-email-error"></span>
              <div class="form-group">
                <label for="email" class="connexion-labels">Email : </label>
                <input type="text" class="form-control" id="email" [(ngModel)]="email">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 col-md-6">
              <span class="text-danger" id="subscribe-password-error"></span>
              <div class="form-group">
                <label for="subscribe-password" class="connexion-labels">Mot de passe : </label>
                <input type="password" class="form-control" id="subscribe-password" [(ngModel)]="password">
              </div>
            </div>
            <div class="col-lg-6 col-md-6">
              <span class="text-danger" id="subscribe-confirm_password-error"></span>
              <div class="form-group">
                <label for="passwordConfirmation" class="connexion-labels">Confirmer le mot de passe : </label>
                <input type="password" class="form-control" id="passwordConfirmation" [(ngModel)]="confirm_password">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div class="form-group" (click)="toggleClick()">
                <label for="email" class="connexion-labels"> Vous cherchez être un annonceur ou un agent ?  </label>
                &lt;!&ndash; Default checked &ndash;&gt;
                <div class="custom-control custom-radio">
                  <input type="radio" class="custom-control-input" id="announcer" name="job" checked>
                  <label class="custom-control-label" for="announcer"> Annonceur : <span  id="announcer-desc"> Publiez vos annonces gratuitement sur notre siteWeb </span></label>
                </div>
                &lt;!&ndash; Default unchecked &ndash;&gt;
                <div class="custom-control custom-radio">
                  <input type="radio" class="custom-control-input" id="agent" name="job">
                  <label class="custom-control-label" for="agent">Agent : <span class="text-muted" id="agent-desc">Si vous cherchez à travailler chez APP360 pour créer des annonces pour nos visiteurs </span> </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body d-none" id="body-confirmation">
        <div class="container">
          <div class="row">
              <div class="form-group">
                <label class="col-lg-6 col-md-6" for="code" class="connexion-labels"> Entrez le code de vérification envoyé à votre email : </label>
                <input class="col-lg-6 col-md-6" type="text" class="form-control" id="code" [(ngModel)]="code">
            </div>
          </div>
        </div>
      </div>
      &lt;!&ndash; Modal footer &ndash;&gt;
      <div class="modal-footer" id="footer-inscription">
        <input type="submit" (click)="subscribe()" class="btn btn-outline-primary" value="Inscrivez-vous">
        <input type="submit" (click)="showConfirmationBlock()" class="btn btn-outline-primary d-none" id="continue" value="Completez votre inscription courrant">
      </div>
      <div class="modal-footer d-none" id="footer-confirmation">
        <input type="submit" (click)="confirm()" class="btn btn-outline-primary" value="Confirmez">
        <input type="submit" (click)="sendConfirmation()" class="btn btn-outline-primary" value="Renvoyer la confirmation a votre mail">
        <input type="submit" (click)="rollback()" class="btn btn-outline-primary" value="Précédent">
      </div>-->
      <div class="modal-header" id="header-inscription">
        <!-- Modal Header -->
        <h5 class="modal-title">{{'register'|translate}}</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-header bg-white d-none" id="header-confirmation">
        <h5 class="modal-title">{{'register2'|translate}} <span *ngIf="username">{{username}}</span></h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="card-signup" id="body-inscription">
        <div class="card-body">
          <div class="row">
            <div class="col-md-5 mr-auto">
              <div class="social text-center">
                <button class="btn btn-just-icon btn-round btn-dribbble">
                  <i class="fa fa-dribbble"></i>
                </button>
                <button href="#facebookSubscribeBlock" data-toggle="modal" class="btn btn-just-icon btn-round btn-facebook" onclick="FBlogin()">
                  <i class="fa fa-facebook"> </i>
                </button>
                <h4 class="mt-3">{{'join'|translate}}</h4>
              </div>
              <div class="form-group has-default">
                <div class="input-group">
                  <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="material-icons">face</i>
                          </span>
                  </div>
                  <input type="text" class="form-control" placeholder="Username..." required [(ngModel)]="username" name="username">
                </div>
                <span class="text-danger float-right" id="subscribe-username-error"></span>
              </div>
              <div class="form-group has-default">
                <div class="input-group">
                  <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="material-icons">mail</i>
                          </span>
                  </div>
                  <input type="text" class="form-control" placeholder="Email..." required [(ngModel)]="email" name="email">
                </div>
                <span class="text-danger float-right" id="subscribe-email-error"></span>
              </div>
              <div class="form-group has-default">
                <div class="input-group">
                  <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="material-icons">lock_outline</i>
                          </span>
                  </div>
                  <input type="password" placeholder="Password..." class="form-control" required [(ngModel)]="password" name="password">
                </div>
                <span class="text-danger float-right" id="subscribe-password-error"></span>
              </div>
              <div class="form-group has-default">
                <div class="input-group">
                  <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="material-icons">lock_outline</i>
                          </span>
                  </div>
                  <input type="password" placeholder="Confirm Password..." class="form-control" required [(ngModel)]="confirm_password" name="confirm_password">
                </div>
                <span class="text-danger float-right" id="subscribe-confirm_password-error"></span>
              </div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" id="announcer" name="job" value="" checked="">
                  <span class="form-check-sign">
                        <span class="check"></span>
                  </span>
                  Announcer
                </label>
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" id="agent" name="job" value="">
                  <span class="form-check-sign">
                        <span class="check"></span>
                  </span>
                  Agent
                </label>
              </div>
              <div class="text-center">
                <a href="javascript:void(0)" class="btn btn-primary btn-round mt-4" (click)="subscribe()">Get Started</a>
              </div>
            </div>
            <div class="col-md-7 ml-auto">
              <div class="info info-horizontal">
                <div class="icon icon-rose">
                  <i class="material-icons">timeline</i>
                </div>
                <div class="description">
                  <h4 class="info-title">{{'annoncer'|translate}}</h4>
                  <p class="description">
                   {{'annoncer_right'|translate}}  </p>
                </div>
              </div>
              <div class="info info-horizontal">
                <div class="icon icon-info">
                  <i class="material-icons">group</i>
                </div>
                <div class="description">
                  <h4 class="info-title">{{'agent'|translate}}</h4>
                  <p class="description">
                    {{'agent_right'|translate}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body bg-white d-none" id="body-confirmation">
        <div class="container">
          <div class="row">
            <div class="form-group">
              <input class="col-lg-6 col-md-6" type="text" class="form-control" id="code" placeholder="Verification Code" [(ngModel)]="code">
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer" id="footer-inscription">
        <input type="submit" (click)="showConfirmationBlock()" class="btn btn-outline-primary d-none" id="continue" value="Completez votre inscription courrant">
      </div>
      <div class="modal-footer bg-white d-none" id="footer-confirmation">
        <input type="submit" (click)="confirm()" class="btn btn-outline-primary" value="Confirmez">
        <input type="submit" (click)="sendConfirmation()" class="btn btn-outline-primary" value="Renvoyer la confirmation a votre mail">
        <input type="submit" (click)="rollback()" class="btn btn-outline-primary" value="Précédent">
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="facebookLoginBlock" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="fb-login-button disabled" data-size="large" data-button-type="login_with" data-layout="default" data-auto-logout-link="false" data-use-continue-as="true" data-width=""></div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <img class="card-img-top" src="assets/pictures/header/facebook.jpeg">
      </div>
      <div class="modal-footer">
        <div class="btn btn-success" (click)="facebook_login()">Confirm</div>
        <div id="close_lfb" type="button" class="btn btn-secondary" data-dismiss="modal">Close</div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="facebookSubscribeBlock" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="fb-login-button disabled" data-size="large" data-button-type="login_with" data-layout="default" data-auto-logout-link="false" data-use-continue-as="true" data-width=""></div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <img class="card-img-top" src="assets/pictures/header/facebook.jpeg">
      </div>
      <div class="modal-footer">
        <div class="btn btn-success" (click)="facebook_subscribe()">Confirm</div>
        <div id="close_sfb" type="button" class="btn btn-secondary" data-dismiss="modal">Close</div>
      </div>
    </div>
  </div>
</div>
